import { footerLinks } from '@/mocks/homeContent';

export default function Footer() {
  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_2fr]">
          {/* brand */}
          <div className="flex flex-col">
            <a href="#top" className="flex items-center gap-2.5 cursor-pointer whitespace-nowrap">
              <span className="relative flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg"></i>
              </span>
              <span className="font-display text-xl font-black tracking-tight text-foreground-950">1黑料网</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-700">
              专注把值得围观的现场与反转，整理成看得懂的热门合集与精选盘点。每日更新，一网打尽精彩内容。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['汇总', '合集', '大全', '盘点'].map((k) => (
                <span
                  key={k}
                  className="rounded-full border border-background-300 bg-background-50/70 px-3 py-1 text-[11px] font-medium text-foreground-700"
                >
                  {k}
                </span>
              ))}
            </div>
          </div>

          {/* links */}
          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3">
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h4 className="mb-4 text-sm font-bold text-foreground-950">{col.title}</h4>
                <ul className="space-y-3">
                  {col.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#top"
                        className="text-[13px] text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer whitespace-nowrap"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 1黑料网 · 汇总 / 合集 / 大全 / 盘点。本站为演示用途，内容静态展示，仅供浏览。</p>
          <p className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-shield-check-line text-primary-600"></i>
            内容均由人工整理 · 尊重事实与版权
          </p>
        </div>
      </div>
    </footer>
  );
}